module.exports = __webpack_public_path__ + "img/cloud.a606a695.svg";